export default "__VITE_ASSET__BkvRJh9Z__"